// extracted by mini-css-extract-plugin
export default {"banner":"OfflineBanner_banner__0FhzD","dismiss":"OfflineBanner_dismiss__5yY8T"};